$(document).ready(function () {

$(document).on('click','.Size .product-form__chips-size-custom button',function(){
    var vsize = $(this).attr('data-button');
    localStorage.setItem("vsize", vsize);  
});

$(document).on('click','.Liner .product-form__chips-size-custom button',function(){
    var vLiner = $(this).attr('data-button');
    localStorage.setItem("vlin", vLiner);  
});

$('.Liner .product-form__chips-size-custom button').each(function() {
    if ($(this).hasClass('selected')) {
         var vLiner = $(this).attr('data-button');
        localStorage.setItem("vlin", vLiner); 
    } 
});
$('.Size .product-form__chips-size-custom button').each(function() {
    if ($(this).hasClass('selected')) {
         var vsize = $(this).attr('data-button');
        localStorage.setItem("vsize", vsize); 
    } 
});
$('.swatch_wrap').each(function() {
    if ($(this).hasClass('active')) {
         var vtitle = $(this).children('a').attr('title');
      $('span.sg_col_name.sg-stpl').text(vtitle);
  } 
});
var vcolor = localStorage.getItem("vcolor");
$('span.sg_col_name.sg-stpl').text(vcolor);
setTimeout(function() {
    var vsize = localStorage.getItem("vsize");
    $('.Size .product-form__chips button[data-button=' + vsize + ']').each(function() {
              $(this).trigger('click');
    });
}, 2500);
$('.Liner .product-form__chips-size-custom button').each(function() {
var xlinear = localStorage.getItem("btnlinear");
    if($(this).attr('data-button') == xlinear)
    {
          $(this).trigger('click');
    }
  
});


});


document.addEventListener('DOMContentLoaded', function() {
  // Listen for changes to any of the variant selections (buttons and select elements)
  const variantSelectors = document.querySelectorAll('.product-form__chip, .product-form__chip-select');

  variantSelectors.forEach(function(selector) {
    selector.addEventListener('click', updateVariantAvailability);
    selector.addEventListener('change', updateVariantAvailability); // For select options
  });

  // Function to update the availability of size and liner options
  function updateVariantAvailability() {
    const selectedSize = document.querySelector('select[name="options[Size]"]').value;
    const selectedLiner = document.querySelector('select[name="options[Liner]"]').value;

    // Update size buttons availability
    const sizeButtons = document.querySelectorAll('.size-option');
    const linerButtons = document.querySelectorAll('.liner-option');

    sizeButtons.forEach(function(button) {
      const sizeValue = button.getAttribute('data-button');
      const variant = getVariant(sizeValue, selectedLiner);
      console.log('hello',variant);
      if (variant && variant.available) {
        button.classList.remove('disabled');
      } else {
        button.classList.add('disabled');
      }
    });

    // Update liner buttons availability
    linerButtons.forEach(function(button) {
      const linerValue = button.getAttribute('data-button');
      const variant = getVariant(selectedSize, linerValue);
      console.log('hello',variant);
      if (variant && variant.available) {
        button.classList.remove('disabled');
      } else {
        button.classList.add('disabled');
      }
    });

    // Update dropdown options availability
    updateDropdownAvailability('Size', selectedLiner);
    updateDropdownAvailability('Liner', selectedSize);
  }

  // Function to get the variant based on selected size and liner
  function getVariant(selectedSize, selectedLiner) {
    if (!window.productVariants) return null;

    return window.productVariants.find(function(variant) {
      return variant.option1 === selectedSize && variant.option2 === selectedLiner;
    });
  }

  // Function to update dropdown options based on availability
  function updateDropdownAvailability(optionName, selectedOtherOption) {
    const dropdown = document.querySelector(`select[name="options[${optionName}]"]`);
    const options = dropdown.querySelectorAll('option');

    options.forEach(function(option) {
      const optionValue = option.value;
      const variant = getVariant(optionName === 'Size' ? optionValue : selectedOtherOption, optionName === 'Liner' ? optionValue : selectedOtherOption);
      
      if (variant && variant.available) {
        option.classList.remove('disabled');
        option.disabled = false;
      } else {
        option.classList.add('disabled');
        option.disabled = true;
      }
    });
  }

  // Update the button UI to show the selected option
  function updateSelectedButtons() {
    const selectedSize = document.querySelector('select[name="options[Size]"]').value;
    const selectedLiner = document.querySelector('select[name="options[Liner]"]').value;

    // Update the size and liner buttons to show selected state
    const sizeButtons = document.querySelectorAll('.size-option');
    const linerButtons = document.querySelectorAll('.liner-option');

    sizeButtons.forEach(function(button) {
      const sizeValue = button.getAttribute('data-button');
      if (sizeValue === selectedSize) {
        button.classList.add('selected');
      } else {
        button.classList.remove('selected');
      }
    });

    linerButtons.forEach(function(button) {
      const linerValue = button.getAttribute('data-button');
      if (linerValue === selectedLiner) {
        button.classList.add('selected');
      } else {
        button.classList.remove('selected');
      }
    });
  }

  // Initial check when the page loads
  updateVariantAvailability();
  updateSelectedButtons();
   const insambtn = document.querySelectorAll('.btn-inseam');

  if (insambtn.length > 0) {
    insambtn.forEach(function(button) {
      button.addEventListener('click', function() {
        console.log('asdasdasdasfasdfasdfwqefqwer');
        setTimeout(function() {
          updateVariantAvailability();
          updateSelectedButtons();
        }, 3000);
      });
    });
  }
   const swatchbtn = document.querySelectorAll('.sg-swatch');

  if (swatchbtn.length > 0) {
    swatchbtn.forEach(function(button) {
      button.addEventListener('click', function() {
        console.log('1111111111111111111111111');
        setTimeout(function() {
          updateVariantAvailability();
          updateSelectedButtons();
        }, 3000);
      });
    });
  }


   // ✅ Event Delegation for dynamically loaded size & liner buttons
  document.body.addEventListener('click', function(event) {
    // If a size button is clicked
    if (event.target.closest('.size-option')) {
      console.log('Size button clicked');
      setTimeout(() => {
        updateVariantAvailability();
        updateSelectedButtons();
      }, 1500);
    }

    // If a liner button is clicked
    if (event.target.closest('.liner-option')) {
      console.log('Liner button clicked');
      setTimeout(() => {
        updateVariantAvailability();
        updateSelectedButtons();
      }, 1500);
    }
  });
  
  //  const linerButtons2 = document.querySelectorAll('.sg_ptrn.sg-swatch');

  // if (linerButtons2.length > 0) {
  //   linerButtons.forEach(function(button) {
  //     button.addEventListener('click', function() {
  //       console.log('22222222222222222');
  //       setTimeout(function() {
  //         updateVariantAvailability();
  //         updateSelectedButtons();
  //       }, 3000);
  //     });
  //   });
  // }
});


document.documentElement.classList.add("js");
/// ---------------------------


function initProductSlider() {
  const $rootSingle = $(".cSlider--single");
  const $rootNav = $(".cSlider--nav");

  $rootSingle.slick({
    slide: ".cSlider__item",
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    fade: false,
    infinite: false,
    useTransform: true,
    speed: 400,
    cssEase: "cubic-bezier(0.77, 0, 0.18, 1)",
    responsive: [{
      breakpoint: 750,
      settings: {
        adaptiveHeight: true,
        arrows: true,
      },
    },],
  });

  $rootNav
    .on("init", function (event, slick) {
      $(this).find(".slick-slide.slick-current").addClass("is-active");
    })
    .slick({
      slide: ".cSlider__item",
      dots: false,
      focusOnSelect: false,
      infinite: false,
      horizontal: true,
      horizontalSwiping: true,
      slidesToShow: 4,
      slidesToScroll: 1,
      arrows: true,
      responsive: [{
        breakpoint: 1024,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 640,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 420,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        },
      },
      ],
    });

  $rootSingle.on("afterChange", function (event, slick, currentSlide) {
    $rootNav.slick("slickGoTo", currentSlide);
    $rootNav.find(".slick-slide.is-active").removeClass("is-active");
    $rootNav
      .find('.slick-slide[data-slick-index="' + currentSlide + '"]')
      .addClass("is-active");
  });

  $rootNav.on("click", ".slick-slide", function (event) {
    event.preventDefault();
    var goToSingleSlide = $(this).data("slick-index");

    $rootSingle.slick("slickGoTo", goToSingleSlide);
  });
}
initProductSlider();
//CD [reapply slider after product render]
document.addEventListener("onProductLoad", function () {
  if ($(window).width() < 640) {
    let image_load_count = 0;
    $(".cSlider--single .main-img").on("load", function () {
      image_load_count++;
    });

    $(".cSlider--single").css("visibility", "hidden");

    const timeId = setInterval(function () {
      if ($(".cSlider--single .main-img").length == image_load_count) {
        $(".cSlider--single").css("visibility", "visible");
        clearInterval(timeId);
        initProductSlider();
      }
    }, 400);
  } else {
    initProductSlider();
  }
});

$(document).ready(function () {
  $(".instagram-custom-inn").slick({
    infinite: true,
    arrows: true,
    dots: true,
    autoplay: true,
    autoplaySpeed: 5000,
    slidesToShow: 4,
    slidesToScroll: 1,
    responsive: [{
      breakpoint: 1170,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
      },
    },
    {
      breakpoint: 750,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
      },
    },
    ],
  });
});
$(document).ready(function () {
  $(".sldier").slick({
    infinite: true,
    arrows: true,
    dots: false,
    autoplay: true,
    autoplaySpeed: 5000,
    slidesToShow: 1,
    prevArrow: $(".preev"),
    nextArrow: $(".nexxt"),
    slidesToScroll: 1,
  });
});

$(document).ready(function () {
  $(".set > a").on("click", function () {
    if ($(this).hasClass("active")) {
      $(this).removeClass("active");
      $(this).siblings(".shopify-section .content").slideUp(200);
      $(".set > a i").removeClass("fa-minus").addClass("fa-plus");
    } else {
      $(".set > a i").removeClass("fa-minus").addClass("fa-plus");
      $(this).find("i").removeClass("fa-plus").addClass("fa-minus");
      $(".set > a").removeClass("active");
      $(this).addClass("active");
      $(".shopify-section .content").slideUp(200);
      $(this).siblings(".shopify-section .content").slideDown(200);
    }
  });
});

$(document).ready(function () {
  $(document).on("click", ".product-single__description h6", function () {
    $(this).toggleClass("active").siblings().removeClass("active");
  });

  if ($(".Size #product-form__chips-size .product-form__chip.selected").length == 0) {
    $(".product-form__cart-size").show();
    $(".product-form__cart-submit ").hide();
  }

  $(document).on("click", ".Size #product-form__chips-size .product-form__chip", function (el) {
    let cstmClass = $(el.currentTarget).parent().data('target');
      $(`.${cstmClass}.product-form__cart-size`).hide();
      $(`.${cstmClass}.product-form__cart-submit `).show();
  });
 
$(document).on("click",'.gmVar',(el)=>{
  $(el.currentTarget).parent().children().removeClass('selected');
  $(el.currentTarget).addClass('selected');
  var tar = el.currentTarget.dataset.button;
  $(el.currentTarget).parent().children('select').children('[value="'+tar+'"]').prop('selected',true);
  gmVarUpdate();
});
function gmVarUpdate(){
  if($('#GMOption1').length != 0 && $('#GMOption2').length != 0 && $('#GMOption3').length != 0){
    $('.gmSelectVar').children(`[data-opt1="${$('#GMOption1').val()}"][data-opt2="${$('#GMOption2').val()}"][data-opt3="$('#GMOption3').val()"]`).prop('selected',true);
  }else if($('#GMOption1').length != 0 && $('#GMOption2').length != 0){
    $('.gmSelectVar').children(`[data-opt1="${$('#GMOption1').val()}"][data-opt2="${$('#GMOption2').val()}"]`).prop('selected',true);
  }else if($('#GMOption1').length != 0){
    $('.gmSelectVar').children(`[data-opt1="${$('#GMOption1').val()}"]`).prop('selected',true);
  }  
}
$(document).on('click','[data-gm-cart]',(el)=>{
  el.preventDefault();
  let varID = $('.gmSelectVar').val();
  const properties = collectLineItemProperties();
  
  $.ajax({
    type: 'POST',
    url: '/cart/add.js',
    data: {
      quantity: 1,
      id: varID,
      properties:properties
    },
    dataType: 'json',
    beforeSend: function () {
      $('[data-gm-cart] .btn__loading-wrap').show('fast');
    },
    success: function (data) {
      console.log('Product added to the Cart');
      window.Shopify.theme.sections.instances[1].components[2].open();
      gmCartUpdate();
      $('[data-gm-cart] .btn__loading-wrap').hide('fast');
    },
    error: function (xhr, status, error) {
      console.error(xhr.responseText);
    }
  });

});
  $(document).on("click", ".liner-option[aria-label='Liner']", function () {
    $(".preorder-descriptions").show();
    $(".product-form__cart-submit .preorder-text").text('Add to cart');
  });
  $(document).on("click", ".liner-option[aria-label='No Liner']", function () {
    $(".preorder-descriptions").hide();
    $(".product-form__cart-submit .preorder-text").text('Add to cart');
  });

  $(document).on(
    "click",
    ".simple_products .product-form__cart-size",
    function (e) {
      e.preventDefault();      
      $("html").animate({
        scrollTop: $(e.currentTarget).parents('form').find('.Size').offset().top - 100,
      });
    }
  );
});
$(".tag_ttl span").click(function () {
  tarClass = $(this).data("swp");
  pagClass = $(this).data("pagi");
  btnClass = $(this).data("col-btn");
  mainClass = $(this).data("main");
  $(
    `.${mainClass} .col_swiper,.${mainClass} .tag_ttl span,.${mainClass} .swiper-pagination,.${mainClass} .col_btn`
  ).removeClass("active");
  $(this).addClass("active");
  $(`.${tarClass}, .${pagClass}, .${btnClass}`).addClass("active");
});
$(".drw_cls").on("click", function () {
  $(".drawer-menu__overlay").click();
});
$(".icn_plus_crs").click(function () {
  if ($(this).hasClass("active")) {
    $(".icn_plus_crs,.mbl_mn_sg,.sg-ttl-head-mbl").removeClass("active");
  } else {
    $(".icn_plus_crs,.mbl_mn_sg,.sg-ttl-head-mbl").removeClass("active");
    $(this).addClass("active");
    var tarClass = $(this).data("target");
    $(`.${tarClass}`).addClass("active");
    $(this).parent().addClass("active");
  }
});
// $('.drw_cls').on('click', function () {
//   $('.drawer-menu__overlay').click();
// });
// $('.icn_plus_crs').click(function () {
//   if ($(this).hasClass('active')) {
//     $('.icn_plus_crs,.mbl_mn_sg,.sg-ttl-head-mbl').removeClass('active');
//   } else {
//     $('.icn_plus_crs,.mbl_mn_sg,.sg-ttl-head-mbl').removeClass('active');
//     $(this).addClass('active');
//     var tarClass = $(this).data('target');
//     $(`.${tarClass}`).addClass('active');
//     $(this).parent().addClass('active');
//   }
// });
$(document).on("mouseover", ".sg-swatch", function () {
  // $(".sg-swatch").removeClass("active");
  // $(this).addClass("active");
  // $(".sg-stpl,.sg-ptrn").html("");
  // $(`.${$(this).data("classname")}`).html($(this).data("name"));

  // CD CODE
  setTimeout(function () {
    if (
      $("#product-form__chips-size .product-form__chip.selected").length == 0
    ) {
      $(".product-form__cart-size").show();
      $(".product-form__cart-submit ").hide();
    }

    // window.addEventListener("scroll", function () {
    //   // load_toggleSticky();
    // });

    // load_toggleSticky();
  }, 2000);
});
/*$(document).on("mouseover", ".swatch_wrap", function () {
  $(".swatch_wrap").removeClass("active");
  $(this).addClass("active");
});*/
$(document).ready(function () {
  var name = $(".swatch_wrap.active > a").data("classname");

  $(`.${name}`).html($(".swatch_wrap.active > a").data("name"));
});
$(".cls_drawer").click(function () {
  $(".quick-cart__overlay").click();
});
$(window).scroll(() => {
  if ($(window).scrollTop() >= 1500)
    $(".bndlStky").css("transform", "translateY(0)");
  else $(".bndlStky").css("transform", "translateY(100%)");
});

// CD CODE
$(document).on(
  "click",
  ".custom_mobile_drawer .main_menu_list .mobile_slide_btn",
  function () {
    var current_slide = $(this).attr("data-id");
    $(".custom_mobile_drawer .main_menu_list .mobile_slide_btn").removeClass(
      "is_btn_active"
    );
    $(
      ".custom_mobile_drawer .menu_block_content .block_mobile_content"
    ).removeClass("is_slide_active");
    $(this).addClass("is_btn_active");
    $("#" + current_slide).addClass("is_slide_active");
  }
);

$(document).on(
  "click",
  ".custom_mobile_drawer .menu_tab .menu_tab_btn",
  function () {
    if ($(this).hasClass("is_tab_open")) {
      $(this).removeClass("is_tab_open");
      $(this).next().slideUp();
    } else {
      $(
        ".custom_mobile_drawer .block_mobile_content.is_slide_active .menu_tab .menu_tab_btn"
      ).removeClass("is_tab_open");
      $(
        ".custom_mobile_drawer .block_mobile_content.is_slide_active .menu_tab .tab_menu_content"
      ).slideUp();
      $(this).addClass("is_tab_open");
      $(this).next().slideDown();
    }
  }
);

$(document).on("click", ".drawer_open_btn", function () {
  if ($(".custom_mobile_drawer").hasClass("is_drawer_open")) {
    $(".drawer_open_btn .icon.open_icon").removeClass("hidden");
    $(".drawer_open_btn .icon.close_icon").addClass("hidden");
    $(".custom_mobile_drawer").removeClass("is_drawer_open");
  } else {
    $(".drawer_open_btn .icon.open_icon").addClass("hidden");
    $(".drawer_open_btn .icon.close_icon").removeClass("hidden");
    $(".custom_mobile_drawer").addClass("is_drawer_open");
  }
});

$(document).ready(function () {
  if ($(window).width() < 960) {
    if ($(".header").length) {
      var announce_bar = 0;
      var header_height = $("#shopify-section-header").height();
      if ($("#shopify-section-announcement-bar").length) {
        announce_bar = $("#shopify-section-announcement-bar").height();
      }
      if ($(window).scrollTop() > announce_bar) {
        $(".custom_mobile_drawer").css({
          top: header_height + "px",
          height: "calc(100vh - " + header_height + "px)",
        });
      } else {
        $(".custom_mobile_drawer").css({
          top: header_height + announce_bar + "px",
          height: "calc(100vh - " + (header_height + announce_bar) + "px)",
        });
      }
    }
  }
});

$(window).scroll(function () {
  if ($(window).width() < 960) {
    if ($(".header").length) {
      var announce_bar = 0;
      var header_height = $("#shopify-section-header").height();
      if ($("#shopify-section-announcement-bar").length) {
        announce_bar = $("#shopify-section-announcement-bar").height();
      }
      if ($(window).scrollTop() > announce_bar) {
        $(".custom_mobile_drawer").css({
          top: header_height + "px",
          height: "calc(100vh - " + header_height + "px)",
        });
      } else {
        $(".custom_mobile_drawer").css({
          top: header_height + announce_bar + "px",
          height: "calc(100vh - " + (header_height + announce_bar) + "px)",
        });
      }
    }
  }
});

// CD CODE
var backgroundDiv = null;
var isSticky = false;

// function load_toggleSticky() {
//   const isMobile = window.innerWidth <= 639;
//   const addToCartButton = document.querySelector(".product-form__cart-submit");
//   const addToCartParent = addToCartButton.parentElement;
//   const parentRect = addToCartParent.getBoundingClientRect();
//   if (parentRect.bottom <= 0 && !isSticky) {
//     isSticky = true;
//     addToCartButton.classList.add("sticky-add-to-cart");

//     backgroundDiv = document.createElement("div");
//     backgroundDiv.classList.add("sticky-add-to-cart-background");
//     document.body.appendChild(backgroundDiv);

//     // Trigger the animation
//     setTimeout(() => {
//       addToCartButton.style.bottom = "0";
//       backgroundDiv.style.bottom = "0";
//     }, 300);
//   } else if (isSticky && parentRect.bottom > 0) {
//     isSticky = false;
//     addToCartButton.style.bottom = "";
//     addToCartButton.classList.remove("sticky-add-to-cart");
//     if (document.querySelectorAll(".sticky-add-to-cart-background").length) {
//       document
//         .querySelectorAll(".sticky-add-to-cart-background")
//         .forEach(function (elem) {
//           elem.remove();
//         });
//     }
//     if (backgroundDiv) {
//       // document.body.removeChild(backgroundDiv);
//       backgroundDiv = null;
//     }
//   }
// }


// sw 
$(document).ready(() => {
  $('.slcPnt').click();
  $('.swRdoInput').on('change', (el) => {
    let shortCount = el.currentTarget.id;
    $('.swfnlPrc').html(el.currentTarget.dataset.price);
    // if (parseInt(shortCount) == 1)
    //   $('.swfnlPrc').html('$66 USD');
    // else if (parseInt(shortCount) == 2)
    //   $('.swfnlPrc').html('$115 USD');
    // else if (parseInt(shortCount) == 3)
    //   $('.swfnlPrc').html('$159 USD');
    // else if (parseInt(shortCount) == 4)
    //   $('.swfnlPrc').html('$200 USD');
    $(`#${shortCount}+.swRdoLstWrap .sg_select`).prop('disabled', true).prop('selectedIndex', 0);
    $('.mainImg').show('fast');
    $(`#${shortCount}+.swRdoLstWrap .swSrt,#${shortCount}+.swRdoLstWrap .SrtHd`).removeClass('active');
    $(`#${shortCount}+.swRdoLstWrap .swSrt1,#${shortCount}+.swRdoLstWrap .SrtHd1`).addClass('active');
    $(`#${shortCount}+.swRdoLstWrap .swSrt1 > div:first-of-type .sw_prop`).prop('disabled', false);
    $(".bdGrid").removeClass("multi").removeClass("single");
    $('.swimg').remove();
    resetAllAvability();
  });
  $('.sw_size').on('change', (el) => {
    el.currentTarget.parentElement.nextElementSibling.childNodes[1].selectedIndex = 0;
    el.currentTarget.parentElement.nextElementSibling.childNodes[1].disabled = false;
    el.currentTarget.parentElement.nextElementSibling.nextElementSibling.childNodes[1].selectedIndex = 0;
    el.currentTarget.parentElement.nextElementSibling.nextElementSibling.childNodes[1].disabled = true;
    el.currentTarget.parentElement.nextElementSibling.nextElementSibling.nextElementSibling.childNodes[1].selectedIndex = 0;
    el.currentTarget.parentElement.nextElementSibling.nextElementSibling.nextElementSibling.childNodes[1].disabled = true;
    resetAvability(el);
  });
  $('.sw_len').on('change', (el) => {
    if (el.currentTarget.value == '5 Inch') {
      $(`.${el.currentTarget.dataset.prdctColor} > option[data-type="seven"]`).prop('disabled', true);
    } else if (el.currentTarget.value == '7 Inch') {
      $(`.${el.currentTarget.dataset.prdctColor} > option[data-type="five"]`).prop('disabled', true);
    }
    $(`.${el.currentTarget.dataset.prdctColor} > option[data-type="five"]`).prop('disabled', true);
    el.currentTarget.parentElement.nextElementSibling.childNodes[1].selectedIndex = 0;
    el.currentTarget.parentElement.nextElementSibling.childNodes[1].disabled = false;
    el.currentTarget.parentElement.nextElementSibling.nextElementSibling.childNodes[1].selectedIndex = 0;
    el.currentTarget.parentElement.nextElementSibling.nextElementSibling.childNodes[1].disabled = true;
    resetAvability(el);
  });
  $('.swLnProp').on('change', (el) => {
    el.currentTarget.parentElement.nextElementSibling.childNodes[1].selectedIndex = 0;
    const prdctSize = el.currentTarget.parentElement.previousElementSibling.previousElementSibling.children[0].value;
    const prdctLength = el.currentTarget.parentElement.previousElementSibling.children[0].value;
    const prdctlean = el.currentTarget.value;
    $(el.currentTarget.parentElement.nextElementSibling.childNodes[1].children).each((i, el) => {
      let handle;
      if (prdctLength == '5 Inch' && $(el).attr('data-type') == 'five') {
        $(el).parent().children('[data-type="seven"]').prop('disabled', true);
        handle = $(el).attr('data-product-five');
      }
      else if (prdctLength == '7 Inch' && $(el).attr('data-type') == 'seven') {
        $(el).parent().children('[data-type="five"]').prop('disabled', true);
        handle = $(el).attr('data-product-seven');
      }
      if (handle != undefined) {
        fetch(handle + '.js')
          .then(response => response.json())
          .then(product => {
            let optn1, optn2;
            if (product.options[0].name.includes("Size")) {
              optn1 = prdctSize;
              optn2 = prdctlean;
            } else if (product.options[0].name.includes("Liner")) {
              optn1 = prdctlean;
              optn2 = prdctSize;
            }
            $(el).attr('data-prdct-img', product.featured_image);
            product.variants.forEach((variant) => {
              if (variant.option1 == optn1 && variant.option2 == optn2) {
                if (variant.available) {
                  $(el).prop('disabled', false).attr('data-prdct-id', variant.id);
                } else
                  $(el).prop('disabled', true);
              }
            });
          });
      } else {
        $(el).prop('disabled', true);
      }
    });
    setTimeout(() => {
      el.currentTarget.parentElement.nextElementSibling.childNodes[1].disabled = false;
      resetAvability(el);
    }, 500);
  });
  $('.sw_product').on('change', (el) => {
    let tar = el.currentTarget.dataset.next;
    let par = el.currentTarget.dataset.par;
    let currectLoop = el.currentTarget.dataset.currectLoop;
    $('.mainImg').hide('fast');
    var pUrl = $(`#${par}+.swRdoLstWrap .swSrt${currectLoop} .sw_product`).children('option:selected').attr('data-prdct-img');

    if ($('.mainImg').hasClass(el.currentTarget.dataset.imgId)) {
      $(`.${el.currentTarget.dataset.imgId}.swimg`).attr('src', pUrl);
    } else {
      var imgEl = `<img class="${el.currentTarget.dataset.imgId} swimg" src="${pUrl}" style="width:100%;" loading="lazy" alt="">`;
      $('.mainImg').addClass(el.currentTarget.dataset.imgId);
    }
    if ($(".bdGrid").hasClass('single') && $(".swRdoInput:checked").data('short') != 1) {
      $(".bdGrid").removeClass("single").addClass("multi");
    } else {
      $(".bdGrid").addClass("single");
    }
    $(".bdCld").append(imgEl);
    $(`#${par}+.swRdoLstWrap .${tar} > div:first-of-type select`).prop('disabled', false);
    const nextLoop = parseInt(currectLoop) + 1;
    $('.SrtHd,.swSrt').removeClass('active');
    $('.SrtHd' + nextLoop + ',.swSrt' + nextLoop).addClass('active');
  });

  $('.sw_size_1').on('change', (el) => {
    el.currentTarget.parentElement.nextElementSibling.childNodes[1].selectedIndex = 0;
    const prdctSize = el.currentTarget.value;
    $(el.currentTarget.parentElement.nextElementSibling.childNodes[1].children).each((i, el) => {
      let handle;
      handle = $(el).attr('data-product-five');
      if (handle != undefined) {
        fetch(handle + '.js')
          .then(response => response.json())
          .then(product => {
            let optn1;
            if (product.options[0].name.includes("Size")) {
              optn1 = prdctSize;
            } 
            $(el).attr('data-prdct-img', product.featured_image);
            product.variants.forEach((variant) => {
              if (variant.option1 == optn1) {
                if (variant.available) {
                  $(el).prop('disabled', false).attr('data-prdct-id', variant.id);
                } else
                  $(el).prop('disabled', true);
              }
            });
          });
      } else {
        $(el).prop('disabled', true);
      }
    });
    setTimeout(() => {
      el.currentTarget.parentElement.nextElementSibling.childNodes[1].disabled = false;
      resetAvability_1(el);
    }, 500);
    
  });
  $('.sw_product_1').on('change', (el) => {
    let tar = el.currentTarget.dataset.next;
    let par = el.currentTarget.dataset.par;
    let currectLoop = el.currentTarget.dataset.currectLoop;
    $('.mainImg').hide('fast');
    var pUrl = $(`#${par}+.swRdoLstWrap .swSrt${currectLoop} .sw_product_1`).children('option:selected').attr('data-prdct-img');

    if ($('.mainImg').hasClass(el.currentTarget.dataset.imgId)) {
      $(`.${el.currentTarget.dataset.imgId}.swimg`).attr('src', pUrl);
    } else {
      var imgEl = `<img class="${el.currentTarget.dataset.imgId} swimg" src="${pUrl}" style="width:100%;" loading="lazy" alt="">`;
      $('.mainImg').addClass(el.currentTarget.dataset.imgId);
    }
    if ($(".bdGrid").hasClass('single') && $(".swRdoInput:checked").data('short') != 1) {
      $(".bdGrid").removeClass("single").addClass("multi");
    } else {
      $(".bdGrid").addClass("single");
    }
    $(".bdCld").append(imgEl);
    $(`#${par}+.swRdoLstWrap .${tar} > div:first-of-type select`).prop('disabled', false);
    const nextLoop = parseInt(currectLoop) + 1;
    $('.SrtHd,.swSrt').removeClass('active');
    $('.SrtHd' + nextLoop + ',.swSrt' + nextLoop).addClass('active');
  });

  
  $('.sw_product,.swLnProp,.sw_prop').on('click', (el) => {
    $('.SrtHd,.swSrt').removeClass('active');
    el.currentTarget.parentElement.parentElement.classList.add('active');
    el.currentTarget.parentElement.parentElement.previousElementSibling.classList.add('active')
  });
  $(".sgChkBtn").click(() => {
    // var formItm = [];
    var formItm = "";
    var validate = true;
    $(".swRdoInput:checked+.swRdoLstWrap .sw_product, .swRdoInput:checked+.swRdoLstWrap .sw_product_1").each((i, el) => {
      if ($(el).find("option:selected").data("prdct-id") != undefined) {
        if (i == 0)
          var tempData = $(el).find("option:selected").data("prdct-id") + ":1";
        else
          var tempData =
            "," + $(el).find("option:selected").data("prdct-id") + ":1";
        formItm = formItm + tempData;
      } else {
        validate = false;
        $(el).addClass("error");
      }
    });

    if (validate) {
      var des = $(".swRdoInput:checked").data("short"),
        locLink;
      if ($(".sgChkBtn").data("page-type") == "shorts") {
       const items = {
      updates: {},
      };
      
      // Split the string into individual entries
      formItm.split(',').forEach(pair => {
      const [id, quantity] = pair.split(':'); // Split each entry into id and quantity
      const parsedId = parseInt(id, 10); // Ensure ID is treated as a number
      const parsedQuantity = parseInt(quantity, 10);
      
      // Accumulate quantities for the same ID (if duplicates exist)
      if (items.updates[parsedId]) {
      items.updates[parsedId] += parsedQuantity;
      } else {
      items.updates[parsedId] = parsedQuantity;
      }
      });
    console.log(items);
          fetch('/cart/update.js', {
          method: 'POST',
          headers: {
          'Content-Type': 'application/json',
          },
          body: JSON.stringify(items),
          })
          .then(response => response.json())
          .then(data => {
          console.log('Cart updated with multiple products:', data);
          // Optionally, update the cart UI or redirect to the cart page
          })
          .catch(error => {
          console.error('Error updating cart:', error);
          });
       setTimeout(() => {
         $('.mycart div').trigger('click');
         }, 500);
return false;
      /*  if (des == 1) locLink = window.Shopify.routes.root + "cart/" + formItm;
        else if (des == 2)
          locLink =
            window.Shopify.routes.root +
            "cart/" +
            formItm +
            "?discount=QGFHQ7E51H4J";
        else if (des == 3)
          locLink =
            window.Shopify.routes.root +
            "cart/" +
            formItm +
            "?discount=D802SNBNNDQM";
        else if (des == 4)
          locLink =
            window.Shopify.routes.root +
            "cart/" +
            formItm +
            "?discount=DT2B814JGW15";
      */
      }
      //window.open(locLink, "_self");
    }
  });
});

function resetAvability(el) {
  // $(".swRdoInput:checked+.swRdoLstWrap .swSrt.active .sw_product").each((i, el) => {
  //.swSrt${i+1}

  $(el.currentTarget).parent().parent().children('.floating-label:last-child').children('select').select2({
    templateSelection: function (data) {
      var colName = $(data.element).data("col-name");
      var colImage = $(data.element).data("image-url");
      var colType = $(data.element).data("type");
      var optionText = data.text;
      if (!colName) {
        return optionText;
      } else if (colName == "image") {
        return $(
          `<span class="${colType} fkOptn"> <span><img src="${colImage}" style="width: 50px; transform: translateY(-25%);"></span> ${optionText}</span>`
        );
      } else {
        return $(
          `<span class="${colType} fkOptn"> <span style="background-color:${colName};" ></span> ${optionText}</span>`
        );
      }
    },
    templateResult: function (data) {
      var colName = $(data.element).data("col-name");
      var colImage = $(data.element).data("image-url");
      var colType = $(data.element).data("type");
      var optionText = data.text;

      if (!colName) {
        return optionText;
      } else if (colName == "image") {
        return $(
          `<span class="${colType} fkOptn"> <span><img src="${colImage}" style="width: 50px; transform: translateY(-25%);"></span> ${optionText}</span>`
        );
      } else {
        return $(
          `<span class="${colType} fkOptn"> <span style="background-color:${colName};" ></span> ${optionText}</span>`
        );
      }
    },
  });
  if (el.currentTarget.parentElement.parentElement.children[1].children[0].value == '5 Inch') {
    $('#select2--results .seven').parent().hide()
  } else if (el.currentTarget.parentElement.parentElement.children[1].children[0].value == '7 Inch') {
    $('#select2--results .five').parent().hide();
  }
  // });
}

function resetAvability_1(el) {
  $(el.currentTarget).parent().parent().children('.floating-label:last-child').children('select').select2({
    templateSelection: function (data) {
      var colName = $(data.element).data("col-name");
      var colImage = $(data.element).data("image-url");
      var colType = $(data.element).data("type");
      var optionText = data.text;
      if (!colName) {
        return optionText;
      } else if (colName == "image") {
        return $(
          `<span class="${colType} fkOptn"> <span><img src="${colImage}" style="width: 50px; transform: translateY(-25%);"></span> ${optionText}</span>`
        );
      } else {
        return $(
          `<span class="${colType} fkOptn"> <span style="background-color:${colName};" ></span> ${optionText}</span>`
        );
      }
    },
    templateResult: function (data) {
      var colName = $(data.element).data("col-name");
      var colImage = $(data.element).data("image-url");
      var colType = $(data.element).data("type");
      var optionText = data.text;

      if (!colName) {
        return optionText;
      } else if (colName == "image") {
        return $(
          `<span class="${colType} fkOptn"> <span><img src="${colImage}" style="width: 50px; transform: translateY(-25%);"></span> ${optionText}</span>`
        );
      } else {
        return $(
          `<span class="${colType} fkOptn"> <span style="background-color:${colName};" ></span> ${optionText}</span>`
        );
      }
    },
  });
}


function resetAllAvability() {
  // $(".swRdoInput:checked+.swRdoLstWrap .swSrt.active .sw_product").each((i, el) => {
  //.swSrt${i+1}
  $(`.swRdoInput:checked+.swRdoLstWrap .swSrt.active .sw_product`).select2({
    templateSelection: function (data) {
      var colName = $(data.element).data("col-name");
      var colImage = $(data.element).data("image-url");
      var colType = $(data.element).data("type");
      var optionText = data.text;
      if (!colName) {
        return optionText;
      } else if (colName == "image") {
        return $(
          `<span class="${colType} fkOptn"> <span><img src="${colImage}" style="width: 50px; transform: translateY(-25%);"></span> ${optionText}</span>`
        );
      } else {
        return $(
          `<span class="${colType} fkOptn"> <span style="background-color:${colName};" ></span> ${optionText}</span>`
        );
      }
    },
    templateResult: function (data) {
      var colName = $(data.element).data("col-name");
      var colImage = $(data.element).data("image-url");
      var colType = $(data.element).data("type");
      var optionText = data.text;

      if (!colName) {
        return optionText;
      } else if (colName == "image") {
        return $(
          `<span class="${colType} fkOptn"> <span><img src="${colImage}" style="width: 50px; transform: translateY(-25%);"></span> ${optionText}</span>`
        );
      } else {
        return $(
          `<span class="${colType} fkOptn"> <span style="background-color:${colName};" ></span> ${optionText}</span>`
        );
      }
    },
  });
  // });
}

// GM quick cart 
shipBarUpdate();
$.ajax({
  type: 'GET',
  url: '/cart.js',
  dataType: 'json',
  beforeSend: function () {
    cartLoader(true);
  },
  success: function (cartData) {
    if (cartData.item_count == 0) {
      $('.sg_draw_bdy,.gmFtrWrap').hide();
      $('.quick_cart__empty').show();
    } else {
      $('.sg_draw_bdy,.gmFtrWrap').show();
      $('.quick_cart__empty').hide();
    }
    cartLoader(false);
  }
})
$(document).ready(() => {
  $(document).on("click", ".itmDel > .icon", (el) => {
    let prdctId = $(el.currentTarget).parent().data('productId');
    $.ajax({
      type: 'POST',
      url: '/cart/change.js',
      data: {
        quantity: 0, // Set quantity to 0 to remove the product
        id: prdctId
      },
      dataType: 'json',
      beforeSend: function () {
        cartLoader(true);
      },
      success: function (data) {
        console.log('Product Removed From the Cart');
        gmCartUpdate();
      },
      error: function (xhr, status, error) {
        console.error(xhr.responseText);
      }
    });
  });
  $(document).on("click", ".gmQnt", (el) => {
    el.preventDefault();
    let qun = el.currentTarget.parentElement.children[1].dataset.gmQty;
    let prdctId;
    if (el.currentTarget.dataset.gmIncrease != undefined) {
      qun++
      prdctId = el.currentTarget.dataset.gmIncrease;
    } else if (el.currentTarget.dataset.gmDecrease != undefined) {
      qun--
      prdctId = el.currentTarget.dataset.gmDecrease;
      if (qun <= 0)
        qun = 0
    }
    el.currentTarget.parentElement.children[1].dataset.qty = qun;
    $.ajax({
      type: 'POST',
      url: '/cart/change.js',
      data: {
        quantity: qun,
        id: prdctId
      },
      dataType: 'json',
      beforeSend: function () {
        cartLoader(true);
      },
      success: function (data) {
        console.log('Product Quantiity Updated');
        gmCartUpdate();
      },
      error: function (xhr, status, error) {
        console.error(xhr.responseText);
      }
    });

  });
  $(document).on("click", ".propOverlay", () => {
    $('.propOverlay,.propWrapBnr').removeClass('active');
  });
  $(document).on("click", ".upsellDrawBtn", () => {
    $('.propOverlay,.propWrapBnr').addClass('active');
  });
  $(document).on("click", ".propBtn", (el) => {
    el.preventDefault();
    let fnd = '';
    $('.gmPropSlct').each((i, el) => {
      if (i == 0)
        fnd = fnd + el.value + ' / ';
      else
        fnd = fnd + el.value;
    });
    $('#variantGM option').removeAttr('selected');
    $('#variantGM option[value="' + fnd + '"]').attr('selected', 'selected');
    gmAddCart($('#variantGM option[value="' + fnd + '"]').data('varnt-id'));
    $('.propOverlay,.propWrapBnr').removeClass('active');
  });
});
function gmAddCart(prdctId) {
  const properties = collectLineItemProperties();
  $.ajax({
    type: 'POST',
    url: '/cart/add.js',
    data: {
      quantity: 1, 
      id: prdctId,
      properties:properties
    },
    dataType: 'json',
    beforeSend: function () {
      cartLoader(true);
    },
    success: function (data) {
      console.log('Product added to the Cart');
      gmCartUpdate();
    },
    error: function (xhr, status, error) {
      console.error(xhr.responseText);
    }
  });
}
function collectLineItemProperties() {
  const form = document.querySelector('[data-product-form]');
  const inputs = form.querySelectorAll('input[name^="properties["].gmInptChk');
  const properties = {};
  inputs.forEach(input => {
    let inputName = input.name.replace('properties[','');
    inputName = inputName.replace(']','');
    if (input.type === 'checkbox' && input.checked) {
      properties[inputName] = input.value ;
    } else if (input.type === 'radio' && input.checked) {
      console.log(inputName)
      properties[inputName] = input.value ;
     } else if(input.type === 'hidden') {
      properties[inputName] = input.value;
    }
  });
  console.log(properties);
  return properties;
}
function gmCartUpdate(check) {
  if(check == undefined)
    check = true
  $.ajax({
    type: 'GET',
    url: '/cart.js',
    dataType: 'json',
    beforeSend: function () {
      cartLoader(true);
    },
    success: function (cartData) {
      $('.gmCounter,span[data-js-cart-count]').html(`${cartData.item_count}`);
      $('.gm_subTtl span').html(`${gmMoney(cartData.items_subtotal_price / 100)}`);
      $('.fillBar').data('cart-total', cartData.items_subtotal_price);
      let propCheck = true;
      shipBarUpdate();
      let freeItemCap = ($('.freeItemCap').html()) * window.Shopify.currency.rate;
      var ctcart = cartData.items_subtotal_price/100;
      if(ctcart < freeItemCap)
      {
        
        $('.freremove svg').trigger('click');
      }
      if(ctcart > freeItemCap)
      {
        $('.my_cc').css('display','block');
      }
      else
      {
        $('.my_cc').css('display','none');
      }
      if(cartData.item_count == 0 ) {
          $('.sg_draw_bdy,.gmFtrWrap').hide();
          $('.quick_cart__empty').show();
        }
      else {
          $('.sg_draw_bdy,.gmFtrWrap').show();
          $('.quick_cart__empty').hide();
          $(cartData.items).each((i, el) => {
             console.log(cartData.items);
          const ttle = el.product_title;
            /*if (ttle.includes('Free Socks')) */
            if (ttle.includes('Free'))
            {
              var dis = 'none';
              var dis1 = 'disabled';
              var dis2 = 'max-content';
              var dis3 = '0px 10px';
              var disl = 'freremove';
            }
          if (ttle.includes('Mystery Item') || ttle.includes('Free'))
            propCheck = false;

          if (i == 0)
            $('div[data-gm-items]').html('');
          let discounts;
          $(el.discounts).each((x, dis) => {
            discounts = dis.title;
          });
                let sizes = [];
$(el.options_with_values).each((x, size) => {
  if (size.value) {
    sizes.push(size.value.split('/'));
  }
});
          if (discounts) {
            $('div[data-gm-items]').append(`
        <div class="quick-cart__item ff-body" data-id="${el.variant_id}" data-handle="${el.url}">
        <div class="quick-cart__item-left">
            <a href="${el.url}">
            <div class="quick-cart__image">
              <div class="image image--responsive gmImage">
                <img src="${el.featured_image.url}" width="70px" height="70px" style="object-fit:cover;" alt="${el.featured_image.alt}" class="">
              </div>
            </div>
            </a>
        </div>
        <div class="quick-cart__item-right">
            <div>
                <div>
                    <h4 class="itmTtl"><a href="${el.url}">${el.product_title}</a></h4>
                        <div class="gmCrtOfr"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18 18" width="14px" height="14px"><path d="M17.78 3.09C17.45 2.443 16.778 2 16 2h-5.165c-.535 0-1.046.214-1.422.593l-6.82 6.89c0 .002 0 .003-.002.003-.245.253-.413.554-.5.874L.738 8.055c-.56-.953-.24-2.178.712-2.737L9.823.425C10.284.155 10.834.08 11.35.22l4.99 1.337c.755.203 1.293.814 1.44 1.533z" fill-opacity=".55" fill="currentColor"></path><path fill="currentColor" d="M10.835 2H16c1.105 0 2 .895 2 2v5.172c0 .53-.21 1.04-.586 1.414l-6.818 6.818c-.777.778-2.036.782-2.82.01l-5.166-5.1c-.786-.775-.794-2.04-.02-2.828.002 0 .003 0 .003-.002l6.82-6.89C9.79 2.214 10.3 2 10.835 2zM13.5 8c.828 0 1.5-.672 1.5-1.5S14.328 5 13.5 5 12 5.672 12 6.5 12.672 8 13.5 8z"></path></svg> <span class="ofrDtl">${discounts}</span> </div>
                </div>
                <span class="itmDel" data-product-id="${el.variant_id}">
                  <span class="icon ">
                    <svg width="100%" viewBox="0 0 24 24">
                          <path d="M0 0h24v24H0V0z" fill="none"></path><path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12 19 6.41z" fill="currentColor"></path>
                    </svg>
                  </span>
                </span>
            </div>
             <div>
                <span class="itmDel 23" data-product-id="${el.variant_id}">
                       Size : ${sizes}
                      </span>
                      </div>
            <div class="gm_control_wrap">
                <div class="quick-cart__control">
                <button class="quick-cart__button gmQnt" data-gm-decrease="${el.variant_id}" href="#">
                    <svg aria-hidden="true" width="12" height="2" viewBox="0 0 12 2" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1 1H11" stroke="#BFBFBF" stroke-width="2" stroke-linecap="round"></path></svg>
                </button>
                <div class="quick-cart__qty ff-body ta-c" data-gm-qty="${el.quantity}">${el.quantity}</div>
                <button class="quick-cart__button gmQnt" data-gm-increase="${el.variant_id}" href="#">
                    <svg width="12" aria-hidden="true" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1 6H11" stroke="#BFBFBF" stroke-width="2" stroke-linecap="round"></path><path d="M6 11L6 1" stroke="#BFBFBF" stroke-width="2" stroke-linecap="round"></path></svg>
                </button>
                </div>
                <div class="prcGmDyn">
                    <span class="money originalPrc" data-product-id="${el.product_id}">${gmMoney(el.original_price / 100)}</span>
                    <span class="money" data-product-id="${el.product_id}">${gmMoney(el.discounted_price / 100)}</span>
                </div>
            </div>
        </div>
        </div> 
        `);
          } else {
            $('div[data-gm-items]').append(`
              <div class="quick-cart__item ff-body" data-id="${el.variant_id}" data-handle="${el.url}">
              <div class="quick-cart__item-left">
                  <a href="${el.url}">
                  <div class="quick-cart__image">
                    <div class="image image--responsive gmImage">
                      <img src="${el.featured_image.url}" width="70px" height="70px" style="object-fit:cover;" alt="${el.featured_image.alt}" class="">
                    </div>
                  </div>
                  </a>
              </div>
              <div class="quick-cart__item-right">
                  <div>
                      <div>
                          <h4 class="itmTtl"><a href="${el.url}">${el.product_title}</a></h4>
                      </div>
                      <span class="itmDel ${disl}" data-product-id="${el.variant_id}">
                        <span class="icon ">
                          <svg width="100%" viewBox="0 0 24 24">
                                <path d="M0 0h24v24H0V0z" fill="none"></path><path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12 19 6.41z" fill="currentColor"></path>
                          </svg>
                        </span>
                      </span>
                  </div>
                   <div>
                <span class="itmDel" data-product-id="${el.variant_id}">
                       Size : ${sizes}
                      </span>
                      </div>
                  <div class="gm_control_wrap">
                      <div class="quick-cart__control" style="width:${dis2}">
                      <button class="quick-cart__button gmQnt" data-gm-decrease="${el.variant_id}" href="#"  style="display:${dis}">
                          <svg aria-hidden="true" width="12" height="2" viewBox="0 0 12 2" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1 1H11" stroke="#BFBFBF" stroke-width="2" stroke-linecap="round"></path></svg>
                      </button>
                      <div class="quick-cart__qty ff-body ta-c" data-gm-qty="${el.quantity}" style="padding:${dis3}" ${dis1}>${el.quantity}</div>
                      <button class="quick-cart__button gmQnt" data-gm-increase="${el.variant_id}" href="#"  style="display:${dis}">
                          <svg width="12" aria-hidden="true" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1 6H11" stroke="#BFBFBF" stroke-width="2" stroke-linecap="round"></path><path d="M6 11L6 1" stroke="#BFBFBF" stroke-width="2" stroke-linecap="round"></path></svg>
                      </button>
                      </div>
                      <div class="prcGmDyn">
                          <span class="money" data-product-id="${el.product_id}">${gmMoney(el.discounted_price / 100)}</span>
                      </div>
                  </div>
              </div>
              </div> `);
            }
          });
        }
  if (propCheck)
    $('.prdctUpsellWrap').show();
  else
    $('.prdctUpsellWrap').hide();
  cartLoader(false);
},
error: function(xhr, status, error) {
  console.error(xhr.responseText);
  alert('Error: Could not retrieve cart details. Please try again.');
  cartLoader(false);
}
});
  
}
// function shipBarUpdate() {
//   // let freeItemCap = ($('.freeItemCap').html()) * window.Shopify.currency.rate; //120 
//   // let freeShipCap = ($('.freeShipCap').html()) * window.Shopify.currency.rate; //150
//     let freeItemCap = ($('.freeItemCap').html()); //120 
//     let freeShipCap = ($('.freeShipCap').html()); //150
//     console.log('hello',freeShipCap);
//     console.log('hello',freeItemCap);
//   let freeShip = (freeItemCap * 100) / freeShipCap;
//  console.log('hello111',freeShip);
//   $('.freeItem').css('left', freeShip + '%');
//   let cartTtl = ($('.fillBar').data('cart-total') / 100);
//   console.log(cartTtl);
//   let fillBarWdth = (cartTtl * 100) / freeShipCap;
//   console.log(fillBarWdth);
//   if (fillBarWdth >= 100) {
//     $('.fillBar').css('width', "100%");
//     //$('.propTxt').html('Get a Free Item applied!').show('fast');
//     $('.propTxt').html('Free shipping applied!').show('fast');
//     $('.propMnTxt').hide('fast');
//     $('.upsellDrawBtn').html('FREE GIFT');
//     $('.upsellCard').addClass('free');
//   } else if (fillBarWdth >= freeShip) {
//     $('.fillBar').css('width', fillBarWdth + "%");
//     //$('.propTxt').html('Free shipping applied!').show('fast');
//      //$('.propTxt').html('Get a Free Item applied!').show('fast');
//    // $('.propMnTxt').show('fast').html(`Spend ${gmMoney(freeItemCap - cartTtl)} more and receive Get a Free Item`);
//     $('.propMnTxt').show('fast').html(`Spend ${gmMoney(freeShipCap - cartTtl)} more and receive free shipping`);
//     $('.upsellDrawBtn').html('Add');
//     $('.upsellCard').removeClass('free');
//   } else {
//     $('.fillBar').css('width', fillBarWdth + "%");
//     $('.propTxt').hide('fast');
//     //$('.propMnTxt').show('fast').html(`Spend ${gmMoney(freeShipCap - cartTtl)} more and receive free shipping`);
//     $('.propMnTxt').show('fast').html(`Spend ${gmMoney(freeShipCap - cartTtl)} more and receive free shipping`);
//     $('.upsellDrawBtn').html('Add');
//     $('.upsellCard').removeClass('free');
//   }
// }
function shipBarUpdate() {
  let freeItemCap = ($('.freeItemCap').html()) * window.Shopify.currency.rate;
  let freeShipCap = ($('.freeShipCap').html()) * window.Shopify.currency.rate;
  let freeShip = (freeShipCap * 100) / freeItemCap;
  $('.freeShip').css('left', freeShip + '%');
  let cartTtl = ($('.fillBar').data('cart-total') / 100);
  let fillBarWdth = (cartTtl * 100) / freeItemCap;
  if (fillBarWdth >= 100) {
    $('.fillBar').css('width', "100%");
    $('.propTxt').html('Get a Free Item applied!').show('fast');
    $('.propMnTxt').hide('fast');
    $('.upsellDrawBtn').html('FREE GIFT');
    $('.upsellCard').addClass('free');
  } else if (fillBarWdth >= freeShip) {
    $('.fillBar').css('width', fillBarWdth + "%");
    $('.propTxt').html('Free shipping applied!').show('fast');
    $('.propMnTxt').show('fast').html(`Spend ${gmMoney(freeItemCap - cartTtl)} more and receive Get a Free Item`);
    $('.upsellDrawBtn').html('Add');
    $('.upsellCard').removeClass('free');
  } else {
    $('.fillBar').css('width', fillBarWdth + "%");
    $('.propTxt').hide('fast');
    $('.propMnTxt').show('fast').html(`Spend ${gmMoney(freeShipCap - cartTtl)} more and receive free shipping`);
    $('.upsellDrawBtn').html('Add');
    $('.upsellCard').removeClass('free');
  }
}
function gmMoney(amt) {
  let cnCode = window.Shopify.locale + '-' + window.Shopify.country;
  let price = Intl.NumberFormat(cnCode, {
    style: 'currency',
    currency: window.Shopify.currency.active,
  });
  return price.format(amt);
}

function cartLoader(act) {
  if(act){
    $('.gmLoad').show('fast');
    $('div[data-gm-items]').hide('fast');
    $('.sg_draw_bdy').addClass('flxCenter');
  }
  else{
    $('.gmLoad').hide('fast');
    $('div[data-gm-items]').show('fast');
    $('.sg_draw_bdy').removeClass('flxCenter');
  }
}
// $('.quick-add__form form').on('submit',()=>{
//   
  // gmCartUpdate();
  // window.Shopify.theme.sections.instances[1].components[2].open();
// })
var targetNode = document.querySelector('.sg_quick_cart'); 
var config = { attributes: true, attributeFilter: ['class'] };
var callback = function(mutationsList, observer) {
    for(var mutation of mutationsList) {
        if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
          
          gmCartUpdate(false);
        }
    }
};
    
var observer = new MutationObserver(callback);
observer.observe(targetNode, config);
$(document).on('submit','.gm-prdctFrm',function(el){
  el.preventDefault();
  
  $(window.Shopify.theme.sections.instances).each((i,ins)=>{
    
    if(ins.productForm != undefined){
      const variant = ins.productForm.getVariant();
        const url = new URL(window.location.href); // or use any URL string
        const value = url.searchParams.get("variant");
if(value)
{
  const value1 = value;
}
else
{
  const value1 = variant.id;
}
      const properties = collectLineItemProperties();
      console.log(variant.id);
        $.ajax({
          type: 'POST',
          url: '/cart/add.js',
          data: {
            quantity: 1, 
            id: value,
            properties:properties
          },
          dataType: 'json',
          beforeSend: function () {
            $('button[data-add-to-cart] .btn__loading-wrap').show('fast');
          },
          success: function (data) {
            console.log('Product added to the Cart');
            gmCartUpdate();
            window.Shopify.theme.sections.instances[1].components[2].open();
            $('button[data-add-to-cart] .btn__loading-wrap').hide('fast');
          },
          error: function (xhr, status, error) {
            console.error(xhr.responseText);
          }
        });
    }
  })
});




$(document).on('change','.variant-select-size',function(){
  console.log($(this).val());
  $('#free_gift_btn').attr('data-variant-id',$(this).val());
});
// $(document).on('click','[data-target="mnPrdct"] > button',(el)=>{
//   let activeVariant = window.Shopify.theme.sections.instances[3].productForm.getVariant();
//   $('.swatch_wrap').each((i,el)=>{
//     let prdctUrl = $(el).children().attr('href');
//     $.ajax({
//       type: 'GET',
//       url: prdctUrl,
//       dataType: 'json',
//       success: function (data) {
//         let slctVar = $('.mpInput').val();
//         debugger
//         data.product.variants.forEach((el,i)=>{
//           if(slctVar = el.id){
//           }
//         });
//       },
//       error: function (xhr, status, error) {
//         console.error(xhr.responseText);
//       }
//     });
//   });
// });

// $(document.body).on('change','.mpInput',(el)=>{
//   debugger
// });

let frmElm = document.getElementsByClassName('gm-prdctFrm')[0];
// $('[data-target="mnPrdct"] > button').on('click',()=>{console.log('adgakjgl238759827953')})
$('.gm-prdctFrm .gmBTn').on('click',()=>{
  checkAvability();
})
document.addEventListener('onProductLoad',()=>{
  $('.gm-prdctFrm .gmBTn').on('click',()=>{
    checkAvability();
  })
})
function checkAvability(){
  setTimeout(()=>{
    const text = $('[data-add-to-cart-text]');
    const btn = $('[data-product-form] [name="add"]')[0];
    const variantId = $('.mpInput').val();
    if ($(`.mpInput option[value="${variantId}"]`).data('qnt') <= 0 && $(`.mpInput option[value="${variantId}"]`).data('avlb')) {
      if(!variantId)
      btn.setAttribute('disabled', 'disabled');
      else{
        $('.preorder-descriptions').removeClass('none');
        btn.removeAttribute('disabled');
        $('.deliveryDate').hide();
      }
      text.html(btn.dataset.langUnavailable);
    } else if ($(`.mpInput option[value="${variantId}"]`).data('avlb')) {
      btn.removeAttribute('disabled');
      $('.preorder-descriptions').addClass('none');
      text.html(btn.dataset.langAvailable);
      $('.deliveryDate').hide();
    } else {
      $('.preorder-descriptions').addClass('none');
      btn.setAttribute('disabled', 'disabled');
      text.html(btn.dataset.langSoldOut);
    }
  },0)
}

document.addEventListener('DOMContentLoaded', function() {
    // Use event delegation
    document.body.addEventListener('click', function(event) {
        if (event.target.classList.contains('ajax-add-to-cart')) {
            var variantId = event.target.getAttribute('data-variant-id');
            fetch('/cart/add.js', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    items: [{
                        id: variantId,
                        quantity: 1
                    }]
                })
            })
            .then(response => {
                if (!response.ok) {
                    throw new Error('Network response was not ok');
                }
                return response.json();
            })
            .then(data => {
                console.log('Item added to cart:', data);
                gmCartUpdate();
            })
            .catch((error) => {
                console.error('Error adding to cart:', error);
            });
        }
    });
});